module.exports = __webpack_public_path__ + "img/item4.8e83ecc3.jpeg";